import { cn } from "@/lib/utils";

export interface ReconciliationTileProps {
  title: string;
  value: string | number;
  subText?: string;
  /** When provided, shows an orange badge with the exception count. */
  exceptionCount?: number;
  className?: string;
}

export function ReconciliationTile({
  title,
  value,
  subText,
  exceptionCount,
  className,
}: ReconciliationTileProps) {
  return (
    <div
      className={cn(
        "relative rounded-lg border bg-card p-4 shadow-sm",
        className,
      )}
      role="region"
      aria-label={title}
    >
      {exceptionCount !== undefined && exceptionCount > 0 && (
        <span
          className="absolute right-3 top-3 inline-flex items-center rounded-full bg-amber-100 px-2 py-0.5 text-xs font-semibold text-amber-800"
          aria-label={`${exceptionCount} exception${exceptionCount !== 1 ? "s" : ""}`}
        >
          {exceptionCount}
        </span>
      )}
      <p className="text-sm font-medium text-muted-foreground">{title}</p>
      <p className="mt-1 text-2xl font-bold tracking-tight">{value}</p>
      {subText && (
        <p className="mt-1 text-xs text-muted-foreground">{subText}</p>
      )}
    </div>
  );
}
